import { codexWindowsPath, siteCanonicalUrl } from '../siteDestinations'

/**
 * Metadados e ficha JSON-LD da página "Como instalar o Codex no Windows"
 * (/como-instalar-o-codex-no-windows/). Mira a busca "como instalar o codex no
 * windows" e vizinhas ("codex app windows", "codex é pago"). As perguntas
 * precisam bater com os títulos visíveis em CodexWindowsPage.tsx (teste).
 */

export const codexWindowsTitle = 'Como instalar o Codex no Windows, sem terminal | Oficina IA'
export const codexWindowsDescription =
  'O Codex vem no aplicativo do ChatGPT para Windows. Onde baixar, como entrar com a sua conta, abrir uma pasta e fazer o primeiro pedido em português.'

export const codexWindowsFaqItems = [
  {
    question: 'Preciso saber programar?',
    answer:
      'Não. Você escreve o que quer em português, como escreveria para um colega, e confere o que saiu. A parte técnica fica com o aplicativo.',
  },
  {
    question: 'E se eu não tenho conta do ChatGPT?',
    answer: 'Crie uma em chatgpt.com. É gratuita e é a mesma conta do celular e do site. Depois é só entrar no aplicativo com ela.',
  },
  {
    question: 'O aplicativo é em português?',
    answer:
      'Ele segue o idioma do Windows. No meu computador, com o Windows em português, os botões apareceram em português: Novo chat, Projetos, Peça qualquer coisa.',
  },
  {
    question: 'Posso instalar no computador do trabalho?',
    answer:
      'Se o computador é da empresa, pode ser que a instalação esteja bloqueada. Nesse caso, pergunte a quem cuida dos computadores. No computador de casa, é só instalar.',
  },
] as const

const pageUrl = `${siteCanonicalUrl}${codexWindowsPath}`
const organizationId = `${siteCanonicalUrl}/#organization`
const websiteId = `${siteCanonicalUrl}/#website`
const shareImageUrl = `${siteCanonicalUrl}/assets/share/oficina-ia-1200x630.png`

export const codexWindowsStructuredData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebPage',
      '@id': `${pageUrl}#webpage`,
      url: pageUrl,
      name: codexWindowsTitle,
      description: codexWindowsDescription,
      inLanguage: 'pt-BR',
      isPartOf: { '@id': websiteId },
      about: { '@id': organizationId },
      primaryImageOfPage: shareImageUrl,
    },
    {
      '@type': 'FAQPage',
      '@id': `${pageUrl}#faq`,
      mainEntity: codexWindowsFaqItems.map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: { '@type': 'Answer', text: item.answer },
      })),
    },
  ],
} as const

export function codexWindowsStructuredDataScript(): string {
  const json = JSON.stringify(codexWindowsStructuredData).replace(/</g, '\\u003c')
  return `<script type="application/ld+json">${json}</script>`
}
